import { useEditor } from '@craftjs/core';
import {
  Button,
  ButtonColor,
} from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/Button';
import {
  LinkProps,
  UniLink,
} from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/UniLink';
import { DeveloperMode } from '@lmt/unicorn-shared/app/components/service/DeveloperMode';
import UndoIcon from '@lmt/unicorn-shared/app/icons/ui-editor/undo.svg?react';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React from 'react';

import styles from './UIEditorSaveResetControls.module.scss';

const StyledLink = (props: LinkProps) => {
  return (
    <UniLink className={styles.link} color={ButtonColor.Primary} {...props} />
  );
};
type Props = {
  isShowControls: boolean;
  save: (config: string) => void;
  resetToDefault: () => void;
  saveToDefault: (config: string) => void;
  isSettingsChanged: boolean;
};

export const UIEditorSaveResetControls: React.FC<Props> = (props) => {
  const { actions, query, canUndo } = useEditor((state, query) => ({
    enabled: state.options.enabled,
    canUndo: query.history.canUndo(),
  }));

  const i18next = useScopedTranslation('editor.topbar');
  if (!props.isShowControls) return null;
  return (
    <div className={styles.controls}>
      <StyledLink
        onClick={() => actions.history.undo()}
        disabled={!canUndo}
        title={i18next.t('undo')}
        icon={<UndoIcon />}
      />
      <StyledLink
        title={i18next.t('default_reset')}
        onClick={() => {
          props.resetToDefault();
        }}
      />
      <DeveloperMode>
        <StyledLink
          title={i18next.t('default_save')}
          onClick={() => {
            const json = query.serialize();
            props.saveToDefault(json);
          }}
        />
      </DeveloperMode>
      <Button
        disabled={!canUndo && !props.isSettingsChanged}
        title={i18next.t('save')}
        color={ButtonColor.Default}
        onClick={() => {
          const json = query.serialize();
          props.save(json);
        }}
        className={styles.button}
      />
    </div>
  );
};
